// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"181":"dbe5deca","335":"21ea382e","470":"ac5400fe"}[chunkId] + ".chunk.css";
};